import { NgModule } from '@angular/core';
import { Ga4GgCartUpdateEntrySuccessEventBuilder } from './ga4-gg-cart-update-entry-success-event.builder';

@NgModule({})
export class Ga4GgCartUpdateEntrySuccessEventModule {
  constructor(_ga4GgCartUpdateEntrySuccessEventBuilder: Ga4GgCartUpdateEntrySuccessEventBuilder) {}
}
